import { formatDate, formatNumber } from '@angular/common';
import { Injectable } from '@angular/core';
import { Observable, Subject, fromEvent, of, map } from 'rxjs';

import { AppService } from './app.service';
import { BaseService } from './base.service';
import { DecimalPipe } from '@angular/common';
import { Router } from '@angular/router';

@Injectable()
export class ApiService {

  //-- VARIABLES -------------------------------------------------------|

  private _meta: any = {};

  private securitiSetup: boolean = false;

  private _appData = new Subject<any>();
  $appData = this._appData.asObservable();

  private lazyLoading = false;
  private _lazyLoading = new Subject<boolean>();
  $lazyLoading = this._lazyLoading.asObservable();

  //-- CONSTRUCTOR -----------------------------------------------------|

  constructor(private http: BaseService, private appService: AppService, private decimalPipe: DecimalPipe, private router: Router) { }

  //-- UTILITY METHODS -------------------------------------------------|

  getData() { return this._meta || {}; }

  private sendIframeReadyEvent(){
    if(this.securitiSetup) return;
    setTimeout(() => { window.parent.postMessage({
      type: 'IFRAME_READY'
    }, '*'); this.securitiSetup = true;}, 0);
  }

  getLazyLoading() { return this.lazyLoading; }

  private API_BASE() {
    return `${this.appService.ENV.API_BASE_URL}/${this.appService.ENV.APP_ID}/promotion/${this.appService.PID}`;
  }

  private resetMeta() {
    this._meta = {};
  }

  public callback() {
    this._appData.next(this._meta);
    this._lazyLoading.next(false)
    this.lazyLoading = false;
    this.appService.setLoadingStatus(false);
    this.sendIframeReadyEvent();
  }

  //-- GET OFFER -------------------------------------------------------|

  public offer() {

    this.resetMeta();

    const url: string = `${this.API_BASE()}`;

    return this.http.get(url)
      .subscribe(
        (response) => {
          this.promoCallback(response);
          
          this.callback();
        },
        (error) => {
          this.redirectHandler(error);
          this.callback();
        });
  }

  promoCallback(response: any) {
    if (response.ErrorMsg != undefined) {
      this.redirectHandler(response.ErrorMsg);
      this.callback()
    }
    this._meta.PROMO = this.appService.PID;;
    this._meta.PROMO_START_DATE = this.dateFormat(response.EffectiveDate);
    this._meta.PROMO_START_DATE_SHORT = this._meta.PROMO_START_DATE.split(",")[0];
    this._meta.PROMO_END_DATE = this.dateFormat(response.ExpirationDate);
    this._meta.PROMO_END_DATE_SHORT = this._meta.PROMO_END_DATE.split(",")[0];
    this._meta.REG_EXP_DATE = this.dateFormat(response.RegistrationExpirationDate);

    this._meta.PROMO_START_DATE_ALT = this.altDateFormat(response.EffectiveDate);
    this._meta.PROMO_END_DATE_ALT = this.altDateFormat(response.ExpirationDate);
    this._meta.REG_EXP_DATE_ALT = this.altDateFormat(response.RegistrationExpirationDate);
    this._meta.REG_EXP_DATE_SHORT_YEAR = this.altDateFormat(response.RegistrationExpirationDate, true);

    var offerData = this.getOfferData(response);
    if(offerData != null){
      this._meta.CLOCK_START = new Date(offerData.CountdownClockStart)
      this._meta.CLOCK_END = new Date(offerData.CountdownClockEnd)
    }
  }

  //-- GET MEMBER PROMOTION --------------------------------------------|

  public memberPromotion(hid: string) {

    const url: string = `${this.API_BASE()}/oneclickregistration/${hid}`;

    this.resetRegisterMetaData();

    return this.http.get(url)
      .subscribe(
        (response) => {
          this.memberPromoCallback(response);
          this.callback();
          this.router.navigate(['confirmation']);
        },
        (error) => {
          this.offer();
          this.redirectHandler(error);
          this.callback();
        });
  }

  //-- REGISTER MEMBER PROMOTION ---------------------------------------|

  public register(cardNumber: string, mpId: string) {
    this._meta.enteredLast4 = cardNumber;
    const url: string = `${this.API_BASE()}/member/${mpId}`;

    const param = { cardNumber: cardNumber};
    
    this.resetRegisterMetaData();

    return this.http.patch(url, param)
      .subscribe(
        (response) => {
          this.memberPromoCallback(response);
          this.callback();
          this.router.navigate(['confirmation']);
        },
        (error) => {
          this.redirectHandler(error);
          this.callback();
        });
  }


  private resetRegisterMetaData() {
    this._meta.ACTION = '';
    this._meta.OFFER_TYPES = [];
  }

  //-- UTILITY METHODS -------------------------------------------------|

  memberPromoCallback(response: any) {
    this._meta.PROMO = sessionStorage.getItem('lyt-auth-pid')
    const offerData = this.getOfferData(response);
    this._meta.FIRST_NAME = response.DisplayName;
    this._meta.CARD_NAME = this.getCardName(offerData.Card.CardName);
    this._meta.MP_ID = response.MpId;
    this._meta.LAST4DIGITS = this.getLast4Digit(offerData.Card);
    this._meta.PNG_FILE_NAME = this.getPngFileName(offerData.Card);


    this._meta.PROMO_START_DATE = this.dateFormat(response.Promotion.EffectiveDate);
    this._meta.PROMO_START_DATE_SHORT = this._meta.PROMO_START_DATE.split(",")[0];
    this._meta.PROMO_END_DATE = this.dateFormat(response.Promotion.ExpirationDate);
    this._meta.PROMO_END_DATE_SHORT = this._meta.PROMO_END_DATE.split(",")[0];
    this._meta.REG_EXP_DATE = this.dateFormat(response.Promotion.RegistrationExpirationDate);

    this._meta.PROMO_START_DATE_ALT = this.altDateFormat(response.Promotion.EffectiveDate);
    this._meta.PROMO_END_DATE_ALT = this.altDateFormat(response.Promotion.ExpirationDate);
    this._meta.PROMO_START_MONTH_DATE = this.dateFormatMonthDate(response.Promotion.EffectiveDate);
    this._meta.REG_EXP_DATE_ALT = this.altDateFormat(response.Promotion.RegistrationExpirationDate);
    this._meta.REG_EXP_DATE_SHORT_YEAR = this.altDateFormat(response.Promotion.RegistrationExpirationDate, true);

    if(response.RegistrationTimestamp == null){

      this._meta.SHOW_CHOICE = true;
      return;
    }

    this._meta.REG_DATE = this.dateFormat(response.RegistrationTimestamp);
    this._meta.REG_EXP_DATE = this.dateFormat(response.Promotion.RegistrationExpirationDate);

    if (offerData != null) {
      this._meta.OPTIN_SELECTED = (offerData.RegisteredPromotionId != null && offerData.RegisteredPromotionId != 'undefined' && offerData.RegisteredPromotionId != '');
      this._meta.ALREADY_REGISTERED = offerData.AlreadyRegistered == 'true';
    }
  }

  registerCallback(response: any) {
    this._meta.REG_DATE = this.dateFormat(response.RegistrationTimestamp);
  }

  getCardName(cardName: string) {
    if (cardName === 'United MileagePlus® Presidential Plus Card') {
      cardName = 'United MileagePlus® Presidential Plus<sup>SM</sup> Card';
    } else if (cardName === 'United MileagePlus® Presidential Plus Business Card') {
      cardName = 'United MileagePlus® Presidential Plus<sup>SM</sup> Business Card';
    }
    return cardName;
  }

  getLast4Digit(card: any) {
    let last4digits = card.Last4;
    // if (!card.NewLast4) {
    //   last4digits = card.Last4;
    // }
    return last4digits;
  }

  getPngFileName(card: any) {
    var cardImgName = 'MileagePlus_Card_Generic_Visa';
    if (card.PngFilePath) {
      cardImgName = card.PngFilePath;
    }
    if(this.appService.ENV.production){
      return 'https://promo.united.com/assets/img/cards/' + cardImgName + '.png';
    }else {
      return 'https://promo.qa.arv.aws.ual.com/assets/img/cards/' + cardImgName + '.png';
    }
    
  }

  getOfferData(response: any) {
    let data = null;

    if (response != undefined
      && response.MetaData != undefined
      && response.MetaData.Offers != undefined
      && response.MetaData.Offers.Offer != undefined) {
      data = response.MetaData.Offers.Offer;
    }

    return data;
  }

  calculateDays(date: string) {
    const currentDate = new Date();
    const givenDate = new Date(date);
  
    const differenceInTime = givenDate.getTime() - currentDate.getTime();
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
  
    return differenceInDays;
  }

  public isAuthenticated(): Observable<boolean> {
    if (sessionStorage.getItem('lyt-auth-token')) {
      return of(true);
    }
    return fromEvent(document, 'micrositeAuth').pipe(map(e => true));
  }

  redirectHandler(error: string) {

    switch (error) {
      case 'PROMOTION:ENDED':
      case 'PROMOTION:NOT_FOUND':
      case 'PROMOTION:ERROR':
        this.router.navigate(['ended']);
        break;
      case 'MEMBER:NOT_FOUND':
      case 'MEMBER:CARD_INVALID':
        this.router.navigate(['error']);
        break;
      case 'ERROR':
      default:
        this.router.navigate(['generic-error']);
        break;
    }
  }

  monthNames: Array<string> = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  
  private dateFormat(res: string) {
    
    if (res != '') {

      const year = res.substring(0, 4);
      const month = parseInt(res.substring(5, 7));
      const day = parseInt(res.substring(8, 10))

      const monthName = this.monthNames[(Number(month) - 1)]

      return `${monthName} ${day}, ${year}`;
    }

    return '';
  }

  private dateFormatMonthDate(res: string) {

    if (res != '') {

      const month = res.substring(5, 7);
      const day = res.substring(8, 10)

      const monthName = this.monthNames[(Number(month) - 1)]

      return `${monthName} ${parseInt(day)}`;
    }

    return '';
  }

  private altDateFormat(res: string, shortYear = false) {

    if (res != '') {

      const year = res.substring(0, 4);
      const month = res.substring(5, 7);
      const day = res.substring(8, 10)
      
      if(shortYear){
        return `${month}/${day}/${year.substring(2, 4)}`;
      }else {
        return `${Number.parseInt(month)}/${Number.parseInt(day)}/${year}`;
      }
      
    }

    return '';
  }

  //--------------------------------------------------------------------|

}